import React from 'react';

const ThreeDSVG = ({ title, is3D = true, ...props }) => (
  <svg aria-label={title} viewBox="0 0 24 24" {...props}>
    {title ? <title id="title">{title}</title> : null}
    <text
      x="50%"
      y="55%"
      dominantBaseline="middle"
      textAnchor="middle"
      fontSize="14"
      fontWeight="bold"
      fill="inherit"
    >
      {is3D ? '2D' : '3D'}
    </text>
  </svg>
);

export default ThreeDSVG; 